// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"172ef4c2","644":"e9fce803"}[chunkId] + ".chunk.js";
};